import React from "react";

function Loader(props) {
  return (
    <div className="loader-con">
      <div className="loader"></div>
    </div>
  );
}

export default Loader;
